export const ACTION_RESET = 'FETCH_SEARCH_RESET';
export const ACTION_SUCCESS = 'FETCH_SEARCH_SUCCESS';
export const ACTION_ERROR = 'FETCH_SEARCH_ERROR';
export const ACTION_SET_OVERLAY_DISPLAY = 'FETCH_SEARCH_SET_OVERLAY_DISPLAY';
export const ACTION_SET_END_PAGE = 'FETCH_SEARCH_SET_END_PAGE';
export const ACTION_SET_SORTING = 'FETCH_SEARCH_SET_SORTING';
